// src/context/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import api from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const storedToken    = localStorage.getItem('token');
  const storedRole     = localStorage.getItem('role');
  const storedUsername = localStorage.getItem('username');
  const storedUserId   = localStorage.getItem('userId');

  const [auth, setAuth] = useState({
    token:    storedToken,
    role:     storedRole,
    username: storedUsername,
    userId:   storedUserId,
  });

  const login = (token, role, username, userId) => {
    localStorage.setItem('token', token);
    localStorage.setItem('role', role);
    localStorage.setItem('username', username);
    localStorage.setItem('userId', userId);
    setAuth({ token, role, username, userId });
  };

  const logout = async () => {
    try {
      // ask the server to clear the HTTP‑only refreshToken cookie
      await api.post('/api/auth/logout');
    } catch (e) {
      console.warn('Logout request failed', e);
    }
    // then clear local storage and React state
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('username');
    localStorage.removeItem('userId');
    setAuth({ token: null, role: null, username: null, userId: null });
  };

  useEffect(() => {
    const tryRefresh = async () => {
      const token = auth.token || localStorage.getItem('token');
      let needsRefresh = false;

      if (!token) {
        // no token at all → we need to refresh or logout
        needsRefresh = true;
      } else {
        try {
          // decode JWT payload
          const [, payloadBase64] = token.split('.');
          const { exp } = JSON.parse(atob(payloadBase64));
          // exp is in seconds since epoch
          if (exp * 1000 < Date.now()) {
            // token expired
            needsRefresh = true;
          }
        } catch (e) {
          // malformed token → force refresh
          needsRefresh = true;
        }
      }

      if (needsRefresh) {
        try {
          const { data } = await api.post('/api/auth/refresh');
          const { accessToken } = data;
          localStorage.setItem('token', accessToken);
          setAuth(prev => ({ ...prev, token: accessToken }));
        } catch (_) {
          // refresh failed → force logout
          logout();
        }
      }
    };

    tryRefresh();
    // run once on mount
  }, []);

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
